<template>
  <b-modal
    v-if="invoice"
    :id="`review-invoice-${invoice.invoiceId}-modal`"
    title="Review Invoice"
    ok-title="Approve"
    cancel-title="Reject"
    ok-variant="success"
    cancel-variant="danger"
    no-close-on-backdrop
    :busy="isProcessing"
    @ok="updateInvoice"
    @cancel="updateInvoice"
    @hidden="$emit('hidden')"
  >
    <b-overlay
      class="position-relative"
      :show="isProcessing"
    >
      <img
        class="position-absolute paid-img"
        src="@/assets/images/invoice/paid.png"
        alt=""
      >
      <div class="d-flex justify-content-end align-items-baseline">
        <p class="mr-1">
          Date:
        </p>
        <h5>{{ `${FORMAT_DATE(invoice.from)} to ${FORMAT_DATE(invoice.to)}` }}</h5>
      </div>

      <div class="d-flex justify-content-between">
        <p>{{ invoice.memo }}</p>
        <h5>{{ formatAmount(invoice.paidAmount - totalExtraPayments) }}</h5>
      </div>
      <div v-if="invoice.extraPayments">
        <div
          v-for="extraPayment, index in invoice.extraPayments.data"
          :key="index"
          class="d-flex justify-content-between"
        >
          <p>{{ extraPayment.payment.record.category.displayName }} <span class="ml-1 text-muted">- {{ extraPayment.payment.record.remarks }}</span></p>
          <h5 :class="{'text-danger': extraPayment.payment.amount < 0}">
            {{ formatAmount(extraPayment.payment.amount) }}
          </h5>
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <p>Total Amount</p>
        <h5>{{ formatAmount(invoice.paidAmount) }}</h5>
      </div>

      <hr>
      <div class="d-flex align-items-baseline">
        <p>
          Paid On:
          <span class="font-weight-bold">{{ `${FORMAT_DATE(invoice.paidOn, 'DD MMM, YYYY')}` }}</span>
        </p>
      </div>

      <p>Remarks: {{ notification.notification.remarks }}</p>
    </b-overlay>
  </b-modal>
</template>

<script>
import { BModal, BOverlay } from 'bootstrap-vue'
import useApollo from '@/plugins/graphql/useApollo'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BModal,
    BOverlay,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    },
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      self: getUserData(),
      isProcessing: false,
      invoice: null,
    }
  },
  computed: {
    totalExtraPayments() {
      let total = 0
      if (this.invoice.extraPayments) {
        total = this.invoice.extraPayments.data.reduce((acc, extra) => acc + extra.payment.amount, 0)
      }
      return total
    },
    invoiceId() {
      return this.notification.notification.invoice.invoiceId
    },
  },
  watch: {
    notification: {
      handler(val) {
        if (this.modalId === `review-invoice-${val.notification.invoice.invoiceId}-modal`) {
          const { invoiceId } = val.notification.invoice
          useApollo.users.getMyInvoice({ invoiceId }).then(response => {
            [this.invoice] = response.data.me.invoices.data
          }).finally(() => {
            this.$bvModal.show(this.modalId)
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateInvoice(bvModal) {
      bvModal.preventDefault()
      this.isProcessing = true
      let decline = true
      if (bvModal.trigger === 'ok') decline = false

      useApollo.users.approveAdjustedInvoice({
        userUid: this.self.uuid,
        projectUid: this.$store.state.project.selectedProject,
        record: Number(this.invoice.invoiceId),
        decline,
      }).then(response => {
        this.showSuccessMessage({
          data: {
            message: response.data.approveAdjustedInvoice.message,
          },
        })
      }).finally(() => {
        this.$emit('refetch')
        this.isProcessing = false
        this.$bvModal.hide(`review-invoice-${this.invoice.invoiceId}-modal`)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.paid-img {
  width: 150px;
  height: auto;
  top: 0;
  right: 30px;
}
</style>
